<template>
  <div class="line-items-holder" ref>
    <template v-if="localLineItems">
    <div class="line-item-headers py-0 pt-3">
      <div class="line-desc"><span class="fake-label">Job Description</span></div>
      <div class="line-tax" v-show="usingTax"><span class="fake-label">{{group.taxLabel || "VAT"}} &percnt;</span></div>
      <div class="line-price-header" >
        <div style="display:inline"><span class="fake-label">Cost </span></div>
        <div v-show="usingTax" style="display:inline">
        <span class="fake-label link" v-if="taxIncluded" @click="toggleTaxIncluded()">(inc {{group.taxLabel || "VAT"}})</span>
        <span class="fake-label link" v-if="!taxIncluded" @click="toggleTaxIncluded()">(exc {{group.taxLabel || "VAT"}})</span>&nbsp;
        </div>
        <!-- <v-tooltip top v-show="usingTax" color="primary" v-if="!$vuetify.breakpoint.xsOnly">
          <div class="pa-2">
            <p class="ma-0">Tax is calculated as part of the total amount (inc VAT) or in addition to it (exc VAT).</p>
          </div>
            <div slot="activator" style="display:inline; cursor:help;">
              <v-icon small color="primary" style="opacity:.5;">help_outline</v-icon>
            </div>
        </v-tooltip> -->
      </div>
    </div>
    <div class="line-items">
      <div class="line-item py-0" v-for="(item, itemsindex) in localLineItems"  :key="item.id">
        <div class="line-desc">
          <v-text-field
          ref="linefocus"
          @focus="$event.target.select()"
          single-line
          name="itemText"
          label=" "
          :id="'itemText-' + itemsindex"
          v-model="item.description"
          required
          placeholder=" "
          hide-details
          @change="updateJobItem(item)"
          @keyup.enter="updateJobItem(item)"
          ></v-text-field>
        </div>
        <div class="line-tax" v-show="usingTax">
          <v-select
              :items="taxRates"
              name="itemTax"
              label=" "
              item-text="rate"
              item-value="rate"
              :id="'itemTax-'+ itemsindex"
              v-model="item.taxRate"
              required
              hide-details
              placeholder=" "
              @input="updateJobItem(item)"
            ></v-select>
          <!-- Tax portion {{item.taxPortion}} <br>linetotal {{item.lineTotal}} -->
        </div>
        <div class="line-price" :class="{ usetax: !usingTax}">
          <v-text-field
            name="itemAmount"
            label=" "
            :id="'itemAmount-'+ itemsindex"
            v-model="item.amount"
            :prefix="currSymbol"
            required
            hide-details
            placeholder=" "
            @focus="$event.target.select()"
            @change="updateJobItem(item)"
            @keyup.enter="updateJobItem(item)"
          ></v-text-field>
        </div>
        <div class="line-delete text-xs-right">
          <v-icon v-if='lineItemCount > 1' @click="deleteJobItem(item.id)" class="small-icon error--text">close</v-icon>
        </div>
      </div>
    </div>
    </template>
    <div v-if="!localLineItems || Object.keys(localLineItems).length === 0">
        <p class="body-small subtle" style="padding: 15px 15px 0 0;">Add the job's items here.</p>
    </div>
    <div class="line-item-headers" style="padding-top: 14px;" :class="{ 'pb-4': !localLineItems }">
      <div class="line-desc" style="align-self:flex-start;">
        <v-btn class="tinybut faded fadegrey--text text-none" depressed small style="margin-left:-1px;" @click="addJobItem({ description: 'Untitled Job', amount: 0.00 })">
          + add item
        </v-btn>
      </div>
      <div class="line-tax" v-show="usingTax && localLineItems">
              <p>
                <span class="fake-label"><strong class="fix-label">Net:</strong></span><br>
                <span class="fake-label"><strong class="fix-label">{{group.taxLabel || "VAT"}}:</strong></span><br>
                <span class="fake-label"><strong class="fix-label">Total:</strong></span><br>
              </p>

      </div>
      <div class="line-price-header" v-show="usingTax && localLineItems">
              <p>
                <span class="fake-label">{{totalNetAmount | toCurrency(lang, currCode) }}</span><br>
                <span class="fake-label">{{totalTaxPortion | toCurrency(lang, currCode) }} </span><br>
                <span class="fake-label">{{amount | toCurrency(lang, currCode) }} </span><br>
              </p>

      </div>
    </div>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import Confirm from '@/components/Shared/Confirm'

export default {
  name: 'LineItems',
  components: {
    Confirm
  },
  props: {
    lineItems: {
      type: Object
    },
    newLineItemKey: {
      type: String,
      required: true
    },
    itemAmount: {
      type: [String, Number]
    },
    itemTotalTaxPortion: {
      type: [String, Number]
    },
    itemTotalNetAmount: {
      type: [String, Number]
    },
    itemTitle: {
      type: [String, Number]
    },
    itemTaxIncluded: {
      type: Boolean
    }
  },
  data () {
    return {
      user: this.$store.getters.user,
      group: this.$store.getters.group,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      amount: this.itemAmount,
      totalTaxPortion: this.itemTotalTaxPortion,
      totalNetAmount: this.itemTotalNetAmount,
      title: this.itemTitle,
      taxIncluded: this.itemTaxIncluded,
      localLineItems: this.lineItems,
      taxRates: this.$store.getters.group.taxRates
    }
  },
  computed: {
    // more descriptive variable for when using tax
    usingTax () {
      return this.group.chargeTax
    },
    lineItemCount () {
      // counts the line items, used on the delete buttons to ensure there is always one item left
      return Object.keys(this.localLineItems).length
    }
  },
  watch: {
    lineItems: {
      handler: function () {
        this.localLineItems = this.lineItems
      },
      deep: true
    }
  },
  methods: {
    addJobItem (payload) {
      // get a new key from firebase via vuex
      const ref = this.newLineItemKey
      // re-roll a key for next time
      this.$emit('create-new-key')
      // check default tax status
      let thisTaxRate = 0
      if (this.usingTax) {
        thisTaxRate = this.group.taxRate
      } else {
        thisTaxRate = 0
      }
      // build object
      const item = {
        id: ref,
        description: payload.description,
        creatorId: this.user.id,
        amount: parseFloat(payload.amount).toFixed(2),
        taxRate: thisTaxRate,
        taxPortion: 0,
        netAmount: 0,
        lineTotal: 0
      }
      // add the item to the local lineItems
      this.localLineItems = {
        ...this.localLineItems,
        [ref]: item
      }
      // now call the local pre emit function
      this.outputLineItems()
      // finally focus the latest input box for ease
      this.$nextTick(() =>
        this.$refs.linefocus[this.$refs.linefocus.length - 1].focus()
      )
    },
    async deleteJobItem (itemId) {
      if (await this.$refs.confirm.open('Delete line item', 'Are you sure?', { color: 'red' })) {
        this.$delete(this.localLineItems, itemId)
        // now send the new data back via our local emit function
        this.outputLineItems()
      }
    },
    recalcJobItem (item) {
      if (!item.amount || isNaN(item.amount)) {
        item.amount = 0.00
      }

      // fix in place to ensure that even jobs with a default tax rate adhere to the group settings.
      let thisTaxRate = 0
      if (this.usingTax) {
        thisTaxRate = item.taxRate
      } else {
        thisTaxRate = 0
      }
      // create new object with lineitem details, use tax and total functions to work out the sums
      const newTaxPortion = this.calcTaxPortion(item.amount, thisTaxRate, this.taxIncluded)
      const newLineTotal = this.calcLineTotal(item.amount, thisTaxRate, this.taxIncluded)
      const newItem = {
        id: item.id,
        description: item.description,
        creatorId: this.user.id,
        amount: parseFloat(item.amount).toFixed(2),
        taxRate: thisTaxRate,
        taxPortion: parseFloat(newTaxPortion).toFixed(2),
        lineTotal: parseFloat(newLineTotal).toFixed(2),
        netAmount: parseFloat(newLineTotal - newTaxPortion).toFixed(2)
      }
      // update the components working copy
      this.localLineItems[item.id] = newItem
    },
    updateJobItem (item) {
      // this function recalcs and then outputs the line items
      // it's split this way so we can call it from the toggleTacIncluded loop without saving each time
      // we can run the calcs then batch update everything
      // run the recalc on this line and update the components working copy
      this.recalcJobItem(item)
      // now send the new data back via our local emit function
      this.outputLineItems()
    },
    calcTaxPortion (amount, taxRate, TaxIncluded) {
      let result = 0
      if (TaxIncluded) {
        result = (amount * (taxRate / 100)) / (1 + (taxRate / 100))
      } else {
        result = (amount * (taxRate / 100))
      }
      return parseFloat(result).toFixed(2)
    },
    calcLineTotal (amount, taxRate, TaxIncluded = false) {
      let result = 0
      // if we dont charge tax then just return the amount
      if (!this.usingTax) {
        result = amount
      }
      // if tax is included in the amount then just return the amount
      if (TaxIncluded) {
        result = amount
      } else {
        // else add the tax on
        result = amount * (1 + (taxRate / 100))
      }
      return parseFloat(result).toFixed(2)
    },
    toggleTaxIncluded () {
      this.taxIncluded = !this.taxIncluded
      // loop through lineitems and recalculate
      const entries = Object.entries(this.localLineItems)
      for (const [itemKey] of entries) {
        let thisItem = this.localLineItems[itemKey]
        this.recalcJobItem(thisItem)
      }
      // now send the new data back via our local emit function
      this.outputLineItems()
    },
    updateTitleAndTotal () {
      let concTitle = []
      let totalAmount = 0
      let totalTaxPortion = 0
      let totalNetAmount = 0
      const entries = Object.entries(this.localLineItems)
      for (const [, itemDetails] of entries) {
        concTitle.push(itemDetails.description)
        totalAmount = parseFloat(totalAmount) + parseFloat(itemDetails.lineTotal)
        totalTaxPortion = parseFloat(totalTaxPortion) + parseFloat(itemDetails.taxPortion)
        totalNetAmount = parseFloat(totalNetAmount) + parseFloat(itemDetails.netAmount)
      }
      this.amount = parseFloat(totalAmount).toFixed(2)
      this.totalTaxPortion = parseFloat(totalTaxPortion).toFixed(2)
      this.totalNetAmount = parseFloat(totalNetAmount).toFixed(2)
      this.title = concTitle.join(', ')
    },
    outputLineItems () {
      // update title and totals

      this.updateTitleAndTotal()
      const updates = {
        amount: this.amount,
        totalTaxPortion: this.totalTaxPortion,
        totalNetAmount: this.totalNetAmount,
        title: this.title,
        taxIncluded: this.taxIncluded,
        lineItems: this.localLineItems
      }
      // emit the new lineItems Object to the parent
      this.$emit('line-items-output', updates)
    },
    fixMissingNetAmount () {
      // this function is to fix any missing net amounts on load
      // it's a bit of a hack but it's the only way to ensure the net amount is always correct for users who predates the
      // net amount field in lineItems and the totalNetAmount in the job
      const entries = Object.entries(this.localLineItems)
      for (const [itemKey] of entries) {
        let thisItem = this.localLineItems[itemKey]
        this.recalcJobItem(thisItem)
      }
      this.outputLineItems()
    }
  },
  created () {
    this.fixMissingNetAmount()
  }
}
</script>

<style scoped lang="scss">
.fix-label{
  display:inline-block;
  width:40px;
}
.v-text-field {
  padding-top:0;
}
.line-items{
  margin-top:-15px;
}
.line-item{
  margin-top:5px;
}
.line-item-headers{
  position:relative;
  z-index:99999;
}
.line-item-headers, .line-item{
  display:flex;
  align-items:center;
  justify-content: flex-start;
}
.line-desc{
  flex-grow: 1;
}
.line-tax{
  // width:60px;
  flex-shrink: 0;
  flex-basis:50px;
  margin-left:10px;
}
.line-price-header{
  flex-shrink: 0;
  flex-basis:105px;
  margin-left:10px;
}
.line-price{
  flex-shrink: 0;
  flex-basis:85px;
  margin-left:10px;
}
.line-delete{
  flex-shrink: 0;
  flex-basis:15px;
  margin-left:5px;
}
.small-icon{
  // width:20px;
  // height:20px;
  font-size:15px;
}
</style>
